import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import { isKaptionPartnerPanelRoute } from './dashboard/kaptionPartner/kaptionPartner.routes';
import AnalyticsHelper from '../helper/AnalyticsHelper';
// NOTICE: KAPTION-INTEGRATION - home-dashboard-app.WEB.6
import { accountLandingPath } from '../helper/kaptionHomeApp';
// NOTICE: KAPTION-INTEGRATION - ai-connectors.CONSENT.1
import {
  rememberPendingConnect,
  takePendingConnect,
  PENDING_CONNECT_CONSENT_ROUTE,
} from '../components/kaption/KaptionAiConnectors/kaptionPendingConnect';

const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  // NOTICE: KAPTION-INTEGRATION - ai-connectors.CONSENT.1: signed in, so
  // either we're on the consent page (forget the parked copy) or we just came
  // back from signing in (return to it).
  const pendingConnect = takePendingConnect();
  if (pendingConnect && to.name !== PENDING_CONNECT_CONSENT_ROUTE) {
    return next(pendingConnect);
  }

  // NOTICE: KAPTION-INTEGRATION - partner-provisioning.PORTAL.6
  // A user with no account membership had nowhere to go: the default landing
  // is `accounts/<account_id>/dashboard`, and with no account that resolved to
  // `accounts/null/...`, which bounces straight back to the login screen.
  // Partner staff are exactly that user, so land them on the partner panel;
  // it explains itself when they hold no partner membership either.
  if (!user?.accounts?.length) {
    return isKaptionPartnerPanelRoute(to.name)
      ? next()
      : next(frontendURL('partner'));
  }

  if (!to.name) {
    // NOTICE: KAPTION-INTEGRATION - home-dashboard-app.WEB.6: root redirect
    // goes to the user's home app for this surface when one is set.
    return next(frontendURL(accountLandingPath(user, user.account_id)));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    // NOTICE: KAPTION-INTEGRATION - ai-connectors.CONSENT.1: park the consent
    // URL before the session check, which can redirect to sign-in on its own.
    rememberPendingConnect(to);
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
